import { useEffect, useRef } from 'react';
import { Info } from 'lucide-react';
import { useDrawer } from '../../components/DrawerSystem';
import InfoPanel from './InfoPanel';
import { useTranslation } from '../../hooks/useTranslation.jsx';

/**
 * InfoDrawerTab — registers the "Tietoa" info tab in the drawer system.
 * Shows workshop context: instance, scenarios, chosen futures, aiheenrajaus.
 * "Where am I?" for participants.
 */
const InfoDrawerTab = ({
  instanceId,
  instanceTitle,
  instanceDescription,
  scenarios,
  scenarioInfo,
  currentViewMode,
  onViewModeChange,
  selectedPerspective,
  participantCount
}) => {
  const { registerTab, unregisterTab } = useDrawer();
  const { t, language } = useTranslation();

  const contextRef = useRef({
    instanceId,
    instanceTitle,
    instanceDescription,
    scenarios,
    scenarioInfo,
    currentViewMode,
    onViewModeChange,
    selectedPerspective,
    participantCount
  });
  contextRef.current = {
    instanceId,
    instanceTitle,
    instanceDescription,
    scenarios,
    scenarioInfo,
    currentViewMode,
    onViewModeChange,
    selectedPerspective,
    participantCount
  };

  useEffect(() => {
    registerTab({
      id: 'info',
      label: t('impactPath.infoTab'),
      icon: <Info size={18} />,
      color: 'rgba(33, 150, 243, 0.3)',
      borderColor: 'rgba(33, 150, 243, 0.5)',
      order: 0, // Above chat
      persistent: true,
      render: () => <InfoPanel contextRef={contextRef} />,
    });

    return () => unregisterTab('info');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [instanceId, language]);

  return null;
};

export default InfoDrawerTab;
